import React, { useState } from 'react';
import { useRouter } from 'next/router';

import { childrenPropTypes } from '../../utils/propTypesUtils';
import { useCart } from './CartProvider';
import { DEPARTING, RETURNING } from '../../pageComponents/indexPage/constants';
import { checkAvailability } from '../../utils/hotelUtils';

export const BookingPathData = React.createContext({});
export const useBookingPath = () => React.useContext(BookingPathData);

const BookingPathProvider = ({ children }) => {
  const { query } = useRouter();
  const { cart } = useCart();
  const [tabDates, setTabDates] = useState({
    [DEPARTING]: {
      selected: null,
      middle: null,
    },
    [RETURNING]: {
      selected: null,
      middle: null,
    },
  });

  const [backupTabDate, setBackupTabDate] = useState({
    [DEPARTING]: null,
    [RETURNING]: null,
  });

  const [isLoyaltyPointsApplied, setIsLoyaltyPointsApplied] = useState(false);

  // filter out the showOrderItems from cart order items
  const showsOrderItem = cart?.order?.items.filter(
    item => item.__typename === 'ShowOrderItem'
  );

  const destinationCode =
    query.d || cart?.order?.items[0].flight?.destination?.code;
  const allowedHotelSaleDestinations =
    cart?.application?.configurations?.allowedHotelSaleDestinations;
  const enableAllowedHotelSaleDestinations =
    cart?.application?.configurations?.enableAllowedHotelSaleDestinations;
  const isStadium = Boolean(query.isStadium) || showsOrderItem?.length > 0;
  const enableExcludedVehicleSaleDestinations =
    cart?.application?.configurations?.enableExcludedVehicleSaleDestinations;
  const excludedVehicleSaleDestinations =
    cart?.application?.configurations?.excludedVehicleSaleDestinations;
  const values = {
    tabDates: tabDates,
    setTabDates: setTabDates,
    isStadium: isStadium,
    showsOrderItem: showsOrderItem,
    isInternational: cart?.order?.isInternational,
    operatedBy: cart?.order?.items[0].flight?.operatedBy,
    backupTabDate,
    setBackupTabDate,
    isLoyaltyPointsApplied,
    setIsLoyaltyPointsApplied,
    isHotelAvailable:
      enableAllowedHotelSaleDestinations && !isStadium
        ? checkAvailability(destinationCode, allowedHotelSaleDestinations)
        : true,
    isVehicleAvailable: enableExcludedVehicleSaleDestinations
      ? !checkAvailability(destinationCode, excludedVehicleSaleDestinations)
      : true,
  };

  return (
    <BookingPathData.Provider value={values}>
      {children}
    </BookingPathData.Provider>
  );
};
BookingPathProvider.propTypes = childrenPropTypes;

export function withAuthentication(WrappedComponent) {
  return function TranslationsHOC(props) {
    return (
      <BookingPathProvider>
        <WrappedComponent {...props} />
      </BookingPathProvider>
    );
  };
}

export default BookingPathProvider;
